var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("label", { attrs: { for: _vm.identification } }, [
      _c("input", {
        class: _vm.className,
        attrs: {
          type: "checkbox",
          id: _vm.identification,
          name: _vm.inputName
        },
        domProps: { checked: _vm.checked },
        on: { change: _vm.sendUpdate }
      }),
      _vm._v("\n      " + _vm._s(_vm.inputLabel) + "\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50b0dec6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50b0dec6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/input/InputCheckbox.vue
// module id = null
// module chunks = 